import { Action, createAction } from '@ngrx/store';

export const ORGANISATION_CONTEXT_SWITCH = `[Meta] Switch Organisation Context`;

export const OrganisationContextSwitch = createAction(ORGANISATION_CONTEXT_SWITCH);
